'use strict';

const $ = window.jQuery;

function get_select2_options() {
    $('.select2-results__options').niceScroll({
        cursorcolor: '#df4d4f',
        cursorborder: '0',
        cursorborderradius: '0',
        cursorwidth: '5px',
        railpadding: { top: 0, right: 0, left: 0, bottom: 0 }
    });
}

function initSelect2() {
    $('.big-select').each(function() {

        if ( $(this).closest('div').hasClass('requires_search') ) {
            $(this).select2({
                width: '100%',
                theme: 'arpej-big',
                minimumInputLength: 3,
                language: {
                    inputTooShort: function(args) {
                        return "Veuillez entrer les " + args.minimum + " premières lettres de votre recherche";
                    },
                }
            }).on('select2:open', function () {
                get_select2_options();
            });
        } else {
            $(this).select2({
                width: '100%',
                theme: 'arpej-big',
                minimumResultsForSearch: -1,
                placeholder: $(this).data('placeholder')
            });
        }

    });

    // Shitty hack to prevent FORMIDABLE FORMS use his fucking !important in his style
    setTimeout(function () {
        $('.select2-hidden-accessible').attr( 'style', 'width: 1px !important;' )
    }, 0)
}

module.exports = function (e) {
    initSelect2()

    $(document).on('frmAfterAddRow frmPageChanged', function () {
        initSelect2()
    })

};
